import { render, staticRenderFns } from "./PersonSign.vue?vue&type=template&id=bd20082a&scoped=true"
import script from "./PersonSign.vue?vue&type=script&lang=js"
export * from "./PersonSign.vue?vue&type=script&lang=js"
import style0 from "./PersonSign.vue?vue&type=style&index=0&id=bd20082a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd20082a",
  null
  
)

export default component.exports